module.exports = __webpack_public_path__ + "img/home-retail-card.f5715a4c.jpg";